import { useLocalSearchParams } from "expo-router"
import { Header } from "components/Header"
import { ExpenseForm } from "@src/components/expense-form"
import { ar } from "i18n/ar"
import { trpc } from "@src/utils"
import { ActivityIndicator } from "react-native"

export default function EditExpense() {
  const params = useLocalSearchParams<{ id: string }>()
  const id = Number(params.id)
  const expense = trpc.expense.get.useQuery({ id: id })

  if (expense.isLoading) {
    return (
      <>
        <Header title={ar.editExpense} />
        <ActivityIndicator color="#3B82F6" className="mt-2" />
      </>
    )
  }

  return (
    <>
      <Header title={ar.editExpense} />
      <ExpenseForm id={id} />
    </>
  )
}
